import * as React from "react";
import { InitialStateMinimumRequirements_PopularCategories } from "./initial-state-minimum-requirements";

import { PopularCategories_CategoryInterface } from "./model";

interface CategoryGridProps {
  useInitialState: () => {
    initialState: InitialStateMinimumRequirements_PopularCategories;
  };
  categories: PopularCategories_CategoryInterface[];
}

export const CategoryGrid: React.FunctionComponent<CategoryGridProps> = (
  props
) => {
  const items = React.useMemo(() => {
    return props.categories.map((category) => {
      return (
        <CategoryGridItem
          category={category}
          useInitialState={props.useInitialState}
        />
      );
    });
  }, [props.categories]);
  return <div className="category-grid">{items}</div>;
};

interface CategoryGridItemProps {
  category: PopularCategories_CategoryInterface;
  useInitialState: () => {
    initialState: InitialStateMinimumRequirements_PopularCategories;
  };
}

const CategoryGridItem: React.FunctionComponent<CategoryGridItemProps> = (
  props
) => {
  const { category } = props;

  const { initialState } = props.useInitialState();
  const { view_file_url } = initialState || {};

  const imageSrc = React.useMemo(() => {
    let directory = view_file_url || "";
    if (!directory.endsWith("/")) {
      directory = `${directory}/`;
    }
    return `${directory}${category.img}`;
  }, [category, view_file_url]);

  const [isHovering, setIsHovering] = React.useState(false);
  const onMouseOver = () => {
    setIsHovering(true);
  };
  const onMouseOut = () => {
    setIsHovering(false);
  };

  return (
    <a
      className="category"
      href={category.href}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    >
      <div className="category-image-aspect-ratio-container">
        <img
          src={imageSrc}
          alt={category.titleText}
          width="200px"
          height="200px"
        />
        <div className={`hover-overlay ${isHovering ? "show" : "hide"}`} />
      </div>
      <p>{category.titleText}</p>
    </a>
  );
};
